import React from "react";
import styled from "styled-components";
import { primaryColor, tuftsBlue } from "../constants/colors";
import { useSelector } from "react-redux";

const CouponBox = ({ heading, code, maxDiscount, validity, onClick }) => {
  const currency = useSelector((state) => state.appSlice.settings.currency);
  return (
    <StyledCouponBox onClick={onClick}>
      <Content>
        <OfferTitle>{heading}</OfferTitle>
        <CouponCode>{code.toUpperCase()}</CouponCode>
      </Content>
      <Details>
        <p className="disc">{`MAX: ${currency}${maxDiscount}`}</p>
        <Validity>{validity}</Validity>
      </Details>
    </StyledCouponBox>
  );
};

export default CouponBox;

const StyledCouponBox = styled.div`
  position: relative;
  border: 2px dashed ${tuftsBlue};
  border-radius: 10px;
  padding: 15px 20px;
  background-color: #ffffff;
  margin: 20px auto;
  text-align: left;
  width: 100%;
  cursor: pointer;

  .disc {
    padding-bottom: 0;
    color: #c7c7c7;
    font-size: 0.8rem;
    font-weight: 400;
    margin-bottom: 0;
  }
`;

const Content = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const OfferTitle = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #333;
`;

const CouponCode = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #007bff;
`;

const Details = styled.div``;

const MaxDiscount = styled.div`
  font-size: 14px;
  color: gray;
  font-weight: 500;
`;

const Validity = styled.div`
  font-size: 12px;
  color: #999;
`;
